import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import {
  IProposal,
  ISeasonCalendarColour,
  ISeasonCalendarDay
} from '@app/activo2/manage-vacations/manage-vacations.interface';

@Component({
  selector: 'app-season-calendar-day',
  templateUrl: './season-calendar-day.component.html',
  styleUrls: ['./season-calendar-day.component.scss']
})
export class SeasonCalendarDayComponent implements OnInit {
  @Input() day!: ISeasonCalendarDay;
  @Input() selectedSlots!: BehaviorSubject<IProposal[]>;
  @Input() defaultColours!: ISeasonCalendarColour;
  @Input() winterSeason!: boolean;

  // eslint-disable-next-line
  readonly BACKGROUND_OPACITY = '70';

  constructor(private elRef: ElementRef) {}

  ngOnInit() {
    this.setColorsDay([]);

    this.selectedSlots.subscribe((slots) => this.setColorsDay(slots));
  }

  /**
   * Set default colors of day to label, border and background.
   */
  private setColorsDay(slots: IProposal[]) {
    const element = this.elRef.nativeElement;
    let backgroundColor = '';
    let borderColor;

    if (this.checkDayInSlot(slots)) {
      backgroundColor = this.defaultColours.secondaryColour + this.BACKGROUND_OPACITY;
      borderColor = this.day.dayType?.primaryColour
        ? this.day.dayType.primaryColour
        : this.defaultColours.primaryColour;
    } else if (this.day.dayType) {
      backgroundColor = this.day.dayType.secondaryColour
        ? this.day.dayType.secondaryColour + this.BACKGROUND_OPACITY
        : '';
      borderColor = this.day.dayType.primaryColour;
    }

    element.style.setProperty('--day-background', backgroundColor);
    element.style.setProperty('--day-border', borderColor);
    element.style.setProperty('--day-label', 'var(--black)');
  }

  private checkDayInSlot(slots: IProposal[]): boolean {
    const dayDate = new Date(this.day.date);
    let dayAppears = false;

    slots.forEach((slot) => {
      const fromDate = new Date(slot.start_date);
      const toDate = new Date(slot.end_date);

      if (dayDate.getTime() <= toDate.getTime() && dayDate.getTime() >= fromDate.getTime()) {
        dayAppears = true;
      }
    });

    return dayAppears;
  }
}
